export const BillingTypes =  [
    {
        name: "Single Funder",
        value: "Single Funder",
    },
    {
        name: "Split Funder",
        value: "Split Funder",
    },
]

export const FunderOneTypes =  [
    {
        name: "Service User",
        value: "Service User",
    },
    {
        name: "Contact",
        value: "Contact",
    },
    {
        name: "Funder",
        value: "Funder",
    },
]

export const SplitFunderOneTypes =  [
    {
        name: "Service User",
        value: "Service User",
    },
    {
        name: "Contact",
        value: "Contact",
    },
    {
        name: "SU Or Contact",
        value: "SU Or Contact",
    },
]